import React from 'react';
import './InvalidAidPage.css';
import { useLanguage } from '../../context/LanguageContext';
import { TranslationOutlined } from '@ant-design/icons';

const LanguageSwitcher = () => {
    const { language, toggleLanguage } = useLanguage();

    return (
        <div className="language-switcher-container" onClick={toggleLanguage}>
            <TranslationOutlined className='language-switcher' />
        </div>
    );
};

export default LanguageSwitcher; 